import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

// USD To SAR ExchangeRate 3.75
export class CurrencyConversionService {
  convertToSAR(amount: number): number {
    // Convert USD to SAR
    return amount * 3.75;
  }

  convertToUSD(amount: number): number {
    // Convert SAR to USD

    return amount / 3.75;
  }
}
